<template>
  <div>
    <Head :title="`${$t('applicants.current_location.information')} - ${data.name}`"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.id}/view`">
        {{ data.name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{$t('applicants.current_location.information')}}
      <span class="text-gray-400 font-medium">/ </span>
      {{ $t('global.update') }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <Form :form-data="form" :locations="locations" :types="types"></Form>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ $t('global.update') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
  },
  layout: Layout,
  props: {
    data: Object,
    locations: Object,
    types: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        'id': this.data.id,
        'actual_location_type': this.data.actual_location_type,
        'actual_location_id': this.data.actual_location_id,
        'actual_location_name': this.data.actual_location_name,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/applicants/${this.data.id}/current-location`)
    },
  },
}
</script>
